import { API_CONFIG, buildApiUrl, getAuthHeaders } from '../config/api.ts';
import { apiRequest } from '../utils/apiRequest.ts';

export interface OpenTableImportedReservation {
  id: number;
  reservationDate: string | null;
  reservationDateRaw: string | null;
  reservationTime: string | null;
  partySize: number;
  guestName: string | null;
  phone: string | null;
  email: string | null;
  occasion: string | null;
  status: string | null;
  tableName: string | null;
  specialRequests: string | null;
  rawRow: Record<string, string> | null;
  importBatchId: string;
  sourceFilename: string | null;
  importedAt: string;
}

export interface PaginatedOpenTableImportsResponse {
  data: OpenTableImportedReservation[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export interface ImportSummary {
  batchId: string;
  totalRows: number;
  imported: number;
  skippedTooSmall: number;
  skippedInvalid: number;
  errors: string[];
}

export interface UpdateOpenTableImportRequest {
  reservationDate?: string;
  reservationTime?: string;
  partySize?: number;
  guestName?: string;
  phone?: string;
  email?: string;
  occasion?: string;
  status?: string;
  tableName?: string;
  specialRequests?: string;
}

export const opentableImportsApi = {
  getAll: (
    params: { page?: number; limit?: number; search?: string },
    token: string
  ): Promise<PaginatedOpenTableImportsResponse> => {
    const q = new URLSearchParams();
    if (params.page) q.append('page', params.page.toString());
    if (params.limit) q.append('limit', params.limit.toString());
    if (params.search) q.append('search', params.search);
    return apiRequest<PaginatedOpenTableImportsResponse>(
      `${buildApiUrl(API_CONFIG.ENDPOINTS.OPENTABLE_IMPORTS.BASE)}?${q}`,
      { method: 'GET', headers: { Authorization: `Bearer ${token}` } }
    );
  },

  uploadCsv: (file: File, token: string): Promise<ImportSummary> => {
    const formData = new FormData();
    formData.append('file', file);
    // Deliberately no Content-Type header here - the browser sets the multipart
    // boundary itself when the body is a FormData instance.
    return apiRequest<ImportSummary>(buildApiUrl(API_CONFIG.ENDPOINTS.OPENTABLE_IMPORTS.UPLOAD), {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    });
  },

  update: (id: number, data: UpdateOpenTableImportRequest, token: string): Promise<OpenTableImportedReservation> =>
    apiRequest<OpenTableImportedReservation>(buildApiUrl(API_CONFIG.ENDPOINTS.OPENTABLE_IMPORTS.BY_ID(id)), {
      method: 'PUT',
      headers: getAuthHeaders(token),
      body: JSON.stringify(data),
    }),

  remove: (id: number, token: string): Promise<void> =>
    apiRequest<void>(buildApiUrl(API_CONFIG.ENDPOINTS.OPENTABLE_IMPORTS.BY_ID(id)), {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    }),
};
